
import api from './api'
import { useCache } from '@/helpers/cache'
import { useDownload } from '@/helpers/download'

export default {
    
    count(params = {}) {

        return api.get('/utilisateurs', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },

    deleteAddress(id, clientAddressId) {

        return api.delete('/utilisateurs/' + id + '/addresses/' + clientAddressId, {})
            
    },

    deleteHabilitation(id, habilitationId) {

        return api.delete('/utilisateurs/' + id + '/habilitations/' + habilitationId, {})
            
    },

    get(id) {

        return api.get('/utilisateurs/' + id, { cache: false })
            .then( json => {

                let utilisateur = json.data

                return utilisateur
            })
            
    },

    getAddresses(id, cache = true) {

        return api.get('/utilisateurs/' + id + '/addresses', { cache })
            .then( json => json.data )
            
    },

    getAll() {

        return api.get('/utilisateurs/all', {})
            .then( json => json.data )
            
    },

    getClients(id) {

        return api.get('/utilisateurs/' + id + '/clients', {})
            .then( json => json.data )
            
    },

    getHabilitations(id, cache = true) {

        return api.get('/utilisateurs/' + id + '/habilitations', { cache })
            .then( json => json.data )
            
    },

    getXlsx(params = {}) {

        return new Promise((resolve, reject) => {

            api.post('/utilisateurs/file', null, { params: params })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun fichier à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        }) 
    },

    getImpersonatables(params = {}) {

        return api.get('/utilisateurs/impersonatables', { params })
            .then( json => json.data )
            
    },

    list(params = {}) {

        return api.get('/utilisateurs', { params })
            .then( json => json.data )
            
    },

    putAddress(id, clientAddressId) {

        return api.put('/utilisateurs/' + id + '/addresses/' + clientAddressId, {})
            
    },

    putHabilitation(id, habilitationId) {

        return api.put('/utilisateurs/' + id + '/habilitations/' + habilitationId, {})
            
    },

    patch(utilisateur) {
        return api.patch('/utilisateurs/' + utilisateur.id, utilisateur)
            .finally(() => {
                useCache().clear('/utilisateurs')
            })
    },

    post(utilisateur) { 
        return api.post('/utilisateurs', utilisateur)
            .finally(() => {
                useCache().clear('/utilisateurs')
            })        
    },

    search(params = {}) {

        return api.get('/utilisateurs', { params })
            .then( json => json.data )            
    } 
}
